import { render, staticRenderFns } from "./kia-labor-time-guide-page.vue?vue&type=template&id=3d0cb400&scoped=true&"
import script from "./kia-labor-time-guide-page.vue?vue&type=script&lang=js&"
export * from "./kia-labor-time-guide-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cb400",
  null
  
)

export default component.exports